import { map } from 'rxjs/operators';

import { AsyncPipe } from '@angular/common';
import { Component, model } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ApmTranslatePipe, AuthFacade, UserPermission } from '@mitsubishi/core';
import { UnitTemplateFacade } from '@mitsubishi/project/data-access';
import { SelectModule } from '@mitsubishi/shared/ui';

@Component({
  selector: 'apm-unit-template-group-selection',
  imports: [AsyncPipe, SelectModule, ApmTranslatePipe, FormsModule],
  templateUrl: './unit-template-group-selection.component.html',
  styleUrl: './unit-template-group-selection.component.css',
})
export class UnitTemplateGroupSelectionComponent {
  canManageUnitTemplate = this.authFacade.hasPermission(UserPermission.UnitTemplateManage);
  selectedGroup = model<string>();
  groups$ = this.unitTemplateFacade.groups$.pipe(
    map(groups => {
      const personalGroups = groups.personalGroups.map(group => ({
        id: group.id,
        name: group.name ?? '-',
        groupName: 448679,
      }));
      const organizationGroups = groups.organizationGroups.map(group => ({
        id: group.id,
        name: group.name ?? '-',
        groupName: 448678,
      }));

      return this.canManageUnitTemplate ? [...personalGroups, ...organizationGroups] : [...personalGroups];
    })
  );

  constructor(
    private unitTemplateFacade: UnitTemplateFacade,
    private authFacade: AuthFacade
  ) {
    this.unitTemplateFacade.loadUnitTemplateGroups();
  }
}
